import React, {useEffect, useContext, useState} from 'react'
import {PurchaseContext} from "../../../context/PurchaseContext";
import {Button, Table} from "antd";
import TaxInput from "./TaxInput";
import TaxName from "./TaxName";
import DeleteTaxRow from "./DeleteTaxRow";

const PurchaseTaxTable = () => {
    const {taxes, updateDeleteCount} = useContext(PurchaseContext)
    const [taxList, setTaxList] = taxes
    const [uniqueKey, setUniqueKey] = useState(0)
    const [tableData, setTableData] = useState([])
    const [deleteCount] = updateDeleteCount


    useEffect(() => {
        setUniqueKey(taxList.length)
        setTableData(taxList)
    }, [taxList])

    const addNewRow = () => {
        setTaxList([
            ...taxList,
            {
                key: uniqueKey + deleteCount,
                taxName: '',
                taxRatio: '',
            }
        ])
        setUniqueKey(oldNumber => oldNumber + 1 + deleteCount)
    }

    const columns = [
        {
            title: 'Vergi Adı',
            dataIndex: 'taxName',
            render: (t, r, i) => <TaxName record={r} rowIndex={i}/>
        },
        {
            title: 'Vergi Oranı',
            dataIndex: 'taxRatio',
            render: (t, r, i) => <TaxInput record={r} rowIndex={i}/>
        },
        {
            title: 'İşlemler',
            render: (t, r, i) => <DeleteTaxRow record={r} rowIndex={i}/>
        }
    ]

    return(
        <React.Fragment>
            <div style={{margin: '32px 0'}}>
                <h4>Vergi Listesi</h4>
            </div>
            <div style={{margin: '8px 0'}}>
                <Button type={'link'} onClick={addNewRow} >Yeni Ekle</Button>
            </div>
            <Table pagination={false} columns={columns} dataSource={tableData} />
        </React.Fragment>
    )
}

export default PurchaseTaxTable